import axios from 'axios'
// import {Notify} from 'vant';
import {Toast} from 'vant';
import qs from 'qs';
import store from '@/store/store'

var baseURL = "http://api.daihing.yn-ce.com/dhb/";
if (process.env.VUE_APP_CURRENTMODE == 'test') {
    baseURL = "http://api.daihing.yn-ce.com/dhb/"
} else if(process.env.VUE_APP_CURRENTMODE == 'production'){
    baseURL = "https://api.cheduoh.com/dhb/"
}
const service = axios.create({
    baseURL: baseURL,
    timeout: 30000,
    // transformRequest: [function (data) {
    //     if (data instanceof FormData) {
    //         return data
    //     }
    //
    //     if (data&&(data['itemAddVo'])) {
    //         return JSON.stringify(data)
    //     }
    //     data = qs.stringify(data);
    //     return data;
    // }],
    // headers: {'Content-Type': 'application/json;charset=UTF-8'}

})

// request interceptor
service.interceptors.request.use(
    config => {
        let token = store.state.token;
        // config.method,config.url,
        let param={};
        if (config.url.indexOf("/member")==0) {

            param['Member-Token']=token
        }
        if(config.method=="get"){

            param=Object.assign(param,config.data);
        }
        let paramStr=""
        for(let key in param){
            paramStr+="&"+key+"="+param[key];
        }
        if(paramStr.length>0){
            paramStr="?"+paramStr.substring(1);
        }
        config.url+=paramStr;

        //console.log(config)
        return config
    }, error => {
        console.log(error) // for debug
    })

// response interceptor
service.interceptors.response.use(
    response => {
        //console.log(response)
        // console.log('返回数据')
        // console.log(response.data.code)
        // console.log(response.data.msg)
        // var code = response.data.code
        // if (code === 1011) {
        //     Toast('登录超时，请重新登录！')
        //     window.location.href = '#/login'
        // }
        // if (code === 6005) {
        //     Toast(response.data.msg)
        //     window.location.href="#/login"
        // }
        // //登录成功
        // if (code === 6006) {
        //     return true
        // }
        //
        // //未注册卖家
        // if (code === 6010) {
        //     Toast(response.data.msg)
        //     window.location.href = '#/login'
        // }
        //
        // //登录失败
        // if (code === 1011) {
        //     return false
        // }
        // if (response.data.code != 0) {
        //     var errorMsg = response.data.msg
        //     if (response && response.data && response.data.result) {
        //         if (response.data.result.errorMsg) {
        //             errorMsg = response.data.result.errorMsg
        //         }
        //         if (response.data.result.messige) {
        //             errorMsg = response.data.result.messige
        //         }
        //         if (response.data.result.msg) {
        //             errorMsg = response.data.result.msg
        //         }
        //         Toast.fail({duration: 2000, message: errorMsg})
        //     }
        //     return Promise.reject(response.data)
        // }
        const result = response.data
        return result
    }, error => {
        console.log(error) // for debug
        Promise.reject(error)
        if(error.message!=null){
            Toast.fail({duration: 2000, message: error.message})
        }else{
            Toast.fail({duration: 2000, message: "未知错误!!!"})
        }

    }
)

export default service
